import axios from 'axios';
import { getToken, clearSession } from './session';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(r => r, (err) => {
  if (err.response?.status === 401) { clearSession(); window.location.reload(); }
  return Promise.reject(err);
});

export const getAuthMembers = () => api.get('/auth/members').then(r => r.data);
export const login = (member_id, passcode) => api.post('/auth/login', { member_id, passcode }).then(r => r.data);
export const getMe = () => api.get('/auth/me').then(r => r.data);

export const adminSetPasscode = (member_id, passcode) => api.put('/admin/set-passcode', { member_id, passcode }).then(r => r.data);
export const adminRevokeAccess = (member_id, revoke) => api.put('/admin/revoke-access', { member_id, revoke }).then(r => r.data);
export const adminGetMembers = () => api.get('/admin/members').then(r => r.data);
export const adminAddMember = (data) => api.post('/admin/add-member', data).then(r => r.data);

export const getHotFiles = () => api.get('/hot-files').then(r => r.data);
export const createHotFile = (data) => api.post('/hot-files', data).then(r => r.data);
export const updateHotFile = (id, data) => api.put(`/hot-files/${id}`, data).then(r => r.data);
export const deleteHotFile = (id) => api.delete(`/hot-files/${id}`).then(r => r.data);
export const completeHotFile = (id) => api.post(`/hot-files/${id}/complete`).then(r => r.data);
export const assignHotFile = (id, data) => api.post(`/hot-files/${id}/assign`, data).then(r => r.data);

export const getTeamMembers = () => api.get('/team-members').then(r => r.data);
export const getSaleContingencies = () => api.get('/sale-contingencies').then(r => r.data);
export const createSaleContingency = (data) => api.post('/sale-contingencies', data).then(r => r.data);
export const updateSaleContingency = (id, data) => api.put(`/sale-contingencies/${id}`, data).then(r => r.data);
export const deleteSaleContingency = (id) => api.delete(`/sale-contingencies/${id}`).then(r => r.data);
export const extendContingency = (id, days) => api.post(`/sale-contingencies/${id}/extend`, { days }).then(r => r.data);

export const getSalesContingencies = () => api.get('/sales-contingencies').then(r => r.data);
export const getSalesContingenciesRiskReport = () => api.get('/sales-contingencies/risk-report').then(r => r.data);
export const summarizeHotFileNotes = (id) => api.post(`/hot-files/${id}/summarize-notes`).then(r => r.data);
export const createSalesContingency = (data) => api.post('/sales-contingencies', data).then(r => r.data);
export const updateSalesContingency = (id, data) => api.put(`/sales-contingencies/${id}`, data).then(r => r.data);
export const deleteSalesContingency = (id) => api.delete(`/sales-contingencies/${id}`).then(r => r.data);

export const getAutoHuddleToday = () => api.get('/ai/auto-huddle/today').then(r => r.data);
export const triggerAutoHuddle = () => api.post('/ai/auto-huddle').then(r => r.data);

export const getGoogleReviews = () => api.get('/google-reviews').then(r => r.data);
export const createGoogleReview = (data) => api.post('/google-reviews', data).then(r => r.data);
export const updateGoogleReview = (id, data) => api.put(`/google-reviews/${id}`, data).then(r => r.data);
export const deleteGoogleReview = (id) => api.delete(`/google-reviews/${id}`).then(r => r.data);

export const getEscalations = () => api.get('/escalations').then(r => r.data);
export const createEscalation = (data) => api.post('/escalations', data).then(r => r.data);
export const updateEscalation = (id, data) => api.put(`/escalations/${id}`, data).then(r => r.data);
export const deleteEscalation = (id) => api.delete(`/escalations/${id}`).then(r => r.data);

export const getActionAlerts = () => api.get('/action-alerts').then(r => r.data);
export const createActionAlert = (data) => api.post('/action-alerts', data).then(r => r.data);
export const dismissActionAlert = (id) => api.put(`/action-alerts/${id}/dismiss`).then(r => r.data);

export const getHistory = () => api.get('/history').then(r => r.data);
export const getPostHuddleActions = () => api.get('/post-huddle-actions').then(r => r.data);
export const createPostHuddleAction = (data) => api.post('/post-huddle-actions', data).then(r => r.data);
export const updatePostHuddleAction = (id, data) => api.put(`/post-huddle-actions/${id}`, data).then(r => r.data);

export const getRecaps = () => api.get('/recaps').then(r => r.data);
export const getRecap = (id) => api.get(`/recaps/${id}`).then(r => r.data);
export const processPostCallRecap = (transcript) => api.post('/ai/post-call-recap', { transcript }).then(r => r.data);
export const exportHotFiles = () => `${API}/export/hot-files`;
export const exportRecap = (id) => `${API}/export/recap/${id}`;

export const getNotifications = () => api.get('/notifications').then(r => r.data);
export const getUnreadCount = () => api.get('/notifications/unread-count').then(r => r.data);
export const markNotificationRead = (id) => api.put(`/notifications/${id}/read`).then(r => r.data);
export const markAllRead = () => api.put('/notifications/read-all').then(r => r.data);
export const testPush = (userId) => api.post('/push/test', { user_id: userId }).then(r => r.data);

// Mobile endpoints
export const getMobileToday = (userInitials) => api.get('/mobile/today', { params: { user_initials: userInitials || '' } }).then(r => r.data);
export const getMobilePipeline = (params = {}) => api.get('/mobile/pipeline', { params }).then(r => r.data);
export const getMobileLoanDetail = (fileId) => api.get(`/mobile/loan/${fileId}`).then(r => r.data);

export const getDashboardStats = () => api.get('/dashboard/stats').then(r => r.data);
export const getCommandCenter = () => api.get('/dashboard/command-center').then(r => r.data);
export const getCarryForward = () => api.get('/dashboard/carry-forward').then(r => r.data);
export const suggestEscalationAction = (id) => api.post(`/escalations/${id}/suggest-action`).then(r => r.data);
export const draftReviewResponse = (id) => api.post(`/reviews/${id}/draft-response`).then(r => r.data);
export const getAlerts = () => api.get('/alerts').then(r => r.data);
export const generateHuddleSummary = () => api.post('/ai/huddle-summary').then(r => r.data);
export const suggestActions = (fileId) => api.post(`/ai/suggest-actions/${fileId}`).then(r => r.data);

export const getReminders = () => api.get('/reminders').then(r => r.data);
export const acknowledgeReminder = (id) => api.put(`/reminders/${id}/acknowledge`).then(r => r.data);
export const seedData = () => api.post('/seed').then(r => r.data);
export const reseedData = () => api.post('/reseed').then(r => r.data);

export const claraChatSend = (message, context, sessionId, userId) => api.post('/clara/chat', { message, context, session_id: sessionId, user_id: userId }).then(r => r.data);
export const claraFullAnalysis = (data) => api.post('/clara/full-analysis', data).then(r => r.data);
export const claraToneAnalysis = (data) => api.post('/clara/tone-analysis', data).then(r => r.data);
export const getClaraPrefs = (userId = 'global') => api.get('/clara/prefs', { params: { user_id: userId } }).then(r => r.data);
export const setClaraPrefs = (data) => api.put('/clara/prefs', data).then(r => r.data);
export const getClaraSecondBrain = () => api.get('/clara/second-brain').then(r => r.data);
export const claraParseEmail = (formData) => api.post('/clara/parse-email', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const claraVoiceTranscribe = (formData) => api.post('/clara/voice', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const claraTrackUsage = (userId, type) => api.post('/clara/track-usage', { user_id: userId, type }).then(r => r.data);
export const getClaraUsage = () => api.get('/admin/clara-usage').then(r => r.data);
export const getAdoptionOverview = (range = 'this_week', start = '', end = '') =>
  api.get('/admin/adoption-overview', { params: { range, start, end } }).then(r => r.data);
export const getActivityFeed = (limit = 100) => api.get('/admin/activity-feed', { params: { limit } }).then(r => r.data);
export const getUserAdoptionDetail = (userId) => api.get(`/admin/user-detail/${userId}`).then(r => r.data);
export const getClaraFlags = () => api.get('/clara/flags').then(r => r.data);
export const resolveClaraFlag = (id) => api.put(`/clara/flags/${id}/resolve`).then(r => r.data);
export const getClaraInsights = () => api.get('/clara/insights').then(r => r.data);
export const getClaraHistory = (borrower) => api.get('/clara/history', { params: borrower ? { borrower } : {} }).then(r => r.data);
export const getClaraHistoryEntry = (id) => api.get(`/clara/history/${id}`).then(r => r.data);
export const getClaraShares = (toInitials) => api.get('/clara/shares', { params: toInitials ? { to_initials: toInitials } : {} }).then(r => r.data);
export const markClaraShareRead = (id) => api.put(`/clara/shares/${id}/read`).then(r => r.data);
export const claraPipelineReview = () => api.get('/clara/pipeline-review').then(r => r.data);
